import { Reveal } from "./Reveal";
import { PREP_LIST, TESTIMONIAL } from "@/lib/site";

export default function Difference() {
  return (
    <section id="difference" className="bg-white py-20 md:py-28">
      <div className="mx-auto grid max-w-[1200px] items-start gap-14 px-5 md:px-8 lg:grid-cols-2 lg:gap-20">
        <Reveal>
          <p className="eyebrow">The SundaySea difference</p>
          <h2 className="mt-4 font-display text-4xl font-light leading-[1.12] text-navy md:text-5xl">
            Flawless results start with <em className="italic">meticulous preparation.</em>
          </h2>
          <p className="mt-6 max-w-xl text-[15px] leading-relaxed text-[#5c6b7a] md:text-base">
            Most painting failures happen because of rushed prep work. At SundaySea, we treat your
            property like our own. We spend the necessary time masking, taping, and covering every
            surface before a single brush touches the wall.
          </p>
          <p className="mt-5 text-lg font-semibold text-navy">We don't just paint — we protect.</p>

          <div className="mt-8 space-y-4">
            {PREP_LIST.map((item) => (
              <div key={item} className="flex items-center gap-4">
                <span className="check-box">
                  <svg viewBox="0 0 24 24" className="h-3.5 w-3.5" fill="none" stroke="currentColor" strokeWidth="3" aria-hidden="true">
                    <path d="M20 6 9 17l-5-5" />
                  </svg>
                </span>
                <p className="text-[15px] text-[#3d4a58]">{item}</p>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.12} className="relative">
          <img
            src="/images/hallway-blue.jpg"
            alt="Repainted arched hallway with wainscoting and crisp lines"
            loading="lazy"
            className="h-[420px] w-full object-cover md:h-[560px]"
          />
          <div className="relative z-10 -mt-16 ml-0 max-w-[320px] bg-navy p-7 text-white shadow-2xl md:-ml-14">
            <span className="font-display text-4xl leading-none text-[#e8a33d]">&ldquo;</span>
            <p className="mt-2 text-[15px] leading-relaxed text-white/90">{TESTIMONIAL.quote}</p>
            <p className="mt-4 text-[11px] uppercase tracking-[0.22em] text-[#e8a33d]">{TESTIMONIAL.author}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
